import { Component, OnInit } from '@angular/core';
import { ConsignmentService } from '../../services/consignment.service';
import { ConsignmentProductService } from '../../services/consignment-product.service';
import { ProductService } from '../../../products/services/product.service';
import { ConsignmentStatusService } from '../../services/consignment-status.service';
import { ProductConsignmentStatusService } from '../../services/product-consignment-status.service';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { ConsignmentPaymentService } from '../../services/consignment-payment.service';
import { ConsignmentReturnService } from '../../services/consignment-return.service';
import { ConsignmentProductStatusService } from '../../services/consignment-product-status.service';
import { Observable } from 'rxjs/Observable';
declare let alasql;

declare var JSZip: any;
declare var JSZipUtils: any;
declare var Docxtemplater: any;
declare var ImageModule: any;
import * as FileSaver from 'file-saver';

import * as moment from 'moment/moment';
moment.locale('es')
import * as _ from 'lodash/lodash';
import { PersonService } from '../../../person/services/person.service';

@Component({
  selector: 'app-list-consignment-states',
  templateUrl: './list-consignment-states.component.html',
  styleUrls: ['./list-consignment-states.component.css'],
  providers:[ConsignmentProductStatusService,ConsignmentPaymentService,ConsignmentService,ConsignmentProductService,
    ProductService,PersonService, ConsignmentStatusService,ProductConsignmentStatusService, LabeledProductService, ConsignmentReturnService]
})
export class ListConsignmentStatesComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  hideDropdown:boolean=false;
  consignments: any = [];
  filters:any = {
    person_nif: {contains: ""},
    person_name: {contains: ""},
    person_surname: {contains: ""},
    consignment_number: {contains: ""},
    product_imei: {contains: ""},
    product_serial_number: {contains: ""},
    product_description: {contains: ""}
  };
  role:number = 3;
  fromDate:any;
  untilDate:any;
  telephone:any;
  person:any = {};
  productConsignmentStatus:any = [];
  productConsignmentStatusWithAll:any = [];
  selectedItems:any = [];
  statusToChange:any;
  exportParams:any = {};
  showExportButton:boolean = true;
  observations:string = null;
  method_of_payment:number = 1;

  constructor(private consignmentService: ConsignmentService, private consignmentProductService:ConsignmentProductService, private productService:ProductService, 
    private personService:PersonService, private consignmentStatusService:ConsignmentStatusService, private productConsignmentStatusService:ProductConsignmentStatusService,
    private labeledProductService: LabeledProductService, private consignmentPaymentService:ConsignmentPaymentService, 
    private consignmentProductStatusService:ConsignmentProductStatusService, private consignmentReturnService:ConsignmentReturnService) { }

  ngOnInit() {
    this.getProductConsignmentStatus().then(()=>{
      try{
        this.role = JSON.parse(localStorage.getItem('user')).role; 
        this.getFilters();
      }catch(e){
        this.getFilters();
      }
    })
  }

  getFilters(){
    this.person = {};
    if (this.telephone){
      this.getPerson({telephone:this.telephone}).then((person)=>{
        this.getConsignmentStatuses(person);
      });
    }else{
      this.getConsignmentStatuses(null);
    }
  }

  
  getPerson(filter){
    return new Promise((resolve, reject) => {
        this.personService.query(filter)
        .subscribe((people) => {
            resolve(people[0]);
        });
    });
  }

  getProductConsignmentStatus(){
    return new Promise((resolve, reject) => {
        this.productConsignmentStatusService.query({})
        .subscribe((statuses) => {
            this.productConsignmentStatus = statuses;
            this.productConsignmentStatusWithAll = _.cloneDeep(this.productConsignmentStatus);
            this.productConsignmentStatusWithAll.unshift({name:"Todas", id:""})
            resolve();
        });
    });
  }

  getConsignmentStatuses(person){
    this.selectedItems = [];
    var params = {
      where: _.cloneDeep(this.filters),
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    if (person && person.nif){
      params.where.nif = person.nif;
    }
    this.consignmentStatusService.query(params)
      .subscribe((consignments) => {
        let countParams = {
          where: _.cloneDeep(params.where),
        };
        this.consignmentStatusService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
          this.consignments = consignments;
          this.consignments.forEach((c)=>{
            if (c.labeled_product_id){
              this.getProductPhotos(c)
            }
          });
      });
  }

  getProductPhotos(c){
    this.labeledProductService.getProductPhotos(c.labeled_product_id)
    .subscribe((result) => {
      if (result && result[0]){
        c.image = result[0].image;
      }
    })
  }

  calculateTotalPayment(){
    let total = 0;
    this.selectedItems.forEach((e)=>{
      total += e.tpv_sale_price*0.60;
    });
    let payment = {
      amount: this.roundValue(total),
      method_of_payment: this.method_of_payment == 1?"Efectivo":this.method_of_payment == 2?"Bizum":this.method_of_payment == 3?"Transferencia":this.method_of_payment == 4?"Otros":"Efectivo",
      document_data: null
    }
    return payment;
  }

  pay(){
    if (this.selectedItems.length > 0){
      let body = this.calculateTotalPayment();
      this.getPerson({nif:this.selectedItems[0].person_nif}).then((person)=>{
        body.document_data = JSON.stringify(this.prepareDownloadObjectToDownloadPayDocument(person));
        this.consignmentPaymentService.create(body).subscribe((payment) =>{
          this.updateStatus(3,2, null, payment.id,null);
          this.downloadPay(payment,JSON.parse(body.document_data));
        });
      });
    }
  }

  return(allowedFromStatus){
    let localSelectedItems = _.cloneDeep(this.selectedItems);
    localSelectedItems.forEach((e)=>{
      if (e.labeled_product_id){
        this.labeledProductService.update({id:e.labeled_product_id, stock:0}).subscribe((labeledProduct) =>{
        });
      }
    });
    this.getPerson({nif:this.selectedItems[0].person_nif}).then((person)=>{
      let body = {document_data: JSON.stringify(this.prepareDownloadObjectToDownloadReturnDocument(person))};
        this.consignmentReturnService.create(body).subscribe((consignmentReturn) =>{
          this.updateStatus(allowedFromStatus, 4, null, null, consignmentReturn.id);
          this.downloadReturn(consignmentReturn,JSON.parse(body.document_data));
        });
    });
  }

  changeToPending(){
    this.updateStatus(1,5, this.observations,null, null);
  } 

  updateStatus(allowedFromStatus, status, observations, consignment_payment_id, consignment_return_id){
    let localSelectedItems = _.cloneDeep(this.selectedItems);
    localSelectedItems.forEach((e)=>{
      if (e.state_id == allowedFromStatus || this.role == 1){
        let consignmentProductStatusBody = {
          consignment_product_id: e.consignment_product_id,
          product_consignment_status_id: status,
          observations:observations,
          consignment_payment_id: consignment_payment_id,
          consignment_return_id: consignment_return_id,
          quantity: e.product_quantity,
          sale_price: e.tpv_sale_price
        }
        this.consignmentProductStatusService.create(consignmentProductStatusBody)
        .subscribe(() => {
          let consignmentProductStatusToUpdateBody = {
            id: e.id,
            quantity:0
          }
          this.consignmentProductStatusService.update(consignmentProductStatusToUpdateBody)
          .subscribe(() => {
            this.getFilters();
          });
        });
      }
    });
  }

  calculateAmountToPay(amount){
    return this.roundValue(amount*0.60);
  }

  roundValue(value){
    return Math.round(value * 100) / 100;
  }
  
  getConsignmentColor(id){
    return this.productConsignmentStatus.filter((e)=> {return e.id === id})[0].color;
  }

  addSelection(consignmentProduct){
    if (consignmentProduct.selected){
      this.selectedItems.push(consignmentProduct);
    }
    this.selectedItems.forEach((e, index) => {
      if (!e.selected){
        this.selectedItems.splice(index,1);
      }
    });
  }


  exportConsingmentsStatuses(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Estado",
              field2:"Código de barras",
              field3:"Nombre",
              field4:"Precio del proveedor",
              field5:"Precio de venta",
              field6:"Fecha de consigna",
              field7:"Fecha de etiquetado",
              field8:"Nº de consigna",
              field9:"Nif Cliente",
              field10:"Nombre Cliente",
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableConsignmentStatusesRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100
        observableConsignmentStatusesRequest.push(this.consignmentStatusService.query(this.exportParams));
      }
      
      Observable.forkJoin(observableConsignmentStatusesRequest)
          .subscribe(data => {
            let p:any = data;
            let consigmentStatuses = p.flat(); 
            consigmentStatuses.forEach(consigmentStatus =>{

                  if (consigmentStatus.labeled_product_name){
                    consigmentStatus.labeled_product_name = consigmentStatus.labeled_product_name.replace(/</g, '');
                    consigmentStatus.labeled_product_name = consigmentStatus.labeled_product_name.replace(/>/g, '');
                    consigmentStatus.labeled_product_name = consigmentStatus.labeled_product_name.replace(/;/g, '');
                    consigmentStatus.labeled_product_name = consigmentStatus.labeled_product_name.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  var row = {
                      field1:consigmentStatus.state?consigmentStatus.state:"",
                      field2:consigmentStatus.labeled_product_barcode?consigmentStatus.labeled_product_barcode:"",
                      field3:consigmentStatus.product_purchase_price?consigmentStatus.product_purchase_price:"",
                      field4:consigmentStatus.product_sale_price?consigmentStatus.product_sale_price:"",
                      field5:consigmentStatus.product_sale_price?consigmentStatus.product_sale_price:"",
                      field6:consigmentStatus.consigment_date?moment(consigmentStatus.consigment_date).format("DD-MM-YYYY"):"",
                      field7:consigmentStatus.labeled_date?moment(consigmentStatus.labeled_date).format("DD-MM-YYYY"):"",
                      field8:consigmentStatus.consignment_number?consigmentStatus.consignment_number:"",
                      field9:consigmentStatus.person_nif?consigmentStatus.person_nif:"",
                      field10:consigmentStatus.person_name?consigmentStatus.person_name + consigmentStatus.person_surname:""
                  }
                  report.push(row);
              });
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:300,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE ESTADOS DE CONSIGNAS'},
                      {columnid:'field4',width:300,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:100,title: ''},
                      {columnid:'field7',width:100,title: ''},
                      {columnid:'field8',width:100,title: ''}, 
                      {columnid:'field9',width:100,title: ''}, 
                      {columnid:'field10',width:100,title: ''}, 
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              }, 
                          6:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                             
                              }
                              },
                          7:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },              
                                  }
                              },
                          8:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },              
                                    }
                                },   
                            9:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1,
                                              },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },              
                                          }
                                      }
                      }   
                },
          };
          this.showExportButton = true;
          alasql.promise('SELECT * INTO XLSXML("ProductosEtiquetados_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
  }


  prepareDownloadObjectToDownloadPayDocument(person){
    let tpvs = [];
    this.selectedItems.forEach((item) =>{
      tpvs.push(
        {
          barcode:item.labeled_product_barcode,
          name:item.labeled_product_name,
          date_sale:moment(item.createdAt).format("DD/MM/YYYY"),
          quantity:item.product_quantity,
          sale_price:item.tpv_sale_price,
          sale_amount:this.roundValue(item.tpv_sale_price*0.60)
        }
      )
    })
    let user = JSON.parse(localStorage.getItem('user'))
    let docData = {
      tpvs: tpvs,
      name: person.name +" "+ person.surname,
      NIF: person.nif,
      address: person.address,
      cp: person.cp,
      state: person.state,
      phone1: person.mobile,
      phone2: person.telephone,
      total: null,
      employee: user.username,
      newdate: moment().format("DD [de] MMMM [de] YYYY"), 
      num: null
    }
    let obj = {
      docData:docData
    }
    return obj
  }

  prepareDownloadObjectToDownloadReturnDocument(person){
    let tpvs = [];
    this.selectedItems.forEach((item) => {
      tpvs.push(
        {
          barcode:item.labeled_product_barcode,
          name:item.labeled_product_name,
          description:item.labeled_product_short_description,
          date_sale:moment(item.createdAt).format("DD/MM/YYYY"),
          quantity:item.product_quantity,
        }
      )
    })
    let user = JSON.parse(localStorage.getItem('user'))
    let docData = {
      tpvs: tpvs,
      name: person.name +" "+ person.surname,
      NIF: person.nif,
      address: person.address,
      cp: person.cp,
      state: person.state,
      phone1: person.mobile,
      phone2: person.telephone,
      total: null,
      employee: user.username,
      newdate: moment().format("DD [de] MMMM [de] YYYY"), 
      num: null
    }
    let obj = {
      docData:docData
    }
    return obj
  }

  downloadPay(payment, docData){
    var opts = {
      centered : false,
      getImage: function(image){
        return image;
      },
    
      getSize: function() {
        return [300,204];
      }
    }

    var imageModule=new ImageModule(opts);
    var _this = this;
  
    this.loadFile("assets/template_pago_depositante.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
      docData.docData.total = payment.amount;
      docData.docData.num = payment.id;
      doc.setData(docData.docData);
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'pago_depositante.docx');  
      //_this.markAsPrinted();     
    })
  }

  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
  }

  downloadReturn(consignmentReturn, docData){
    var opts = {
      centered : false,
      getImage: function(image){
        return image;
      },
    
      getSize: function() {
        return [300,204];
      }
    }

    var imageModule=new ImageModule(opts);
  
    this.loadFile("assets/template_devolucion_depositante.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
    
      docData.docData.num = consignmentReturn.id;
      doc.setData(docData.docData);   
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'devolucion_depositante.docx');  
      //_this.markAsPrinted();     
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/consignment/components/list-consignment-states/list-consignment-states.component.ts